import { get } from 'lodash';
import * as Yup from 'yup';

export const columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'name', headerName: 'Name', width: 250 },
  { field: 'default_duration', headerName: 'Duration (mins)', width: 190 },
  { field: 'equipment_type', headerName: 'Equipment Type', width: 200 },
];

export const suggestionPrimaryKey = 'name';
export const suggestionSecondaryKeys = ['default_duration', 'equipment_type'];

export const initialValues = (service) => {
  const { equipment_type: equipmentType } = service || {};
  return {
    name: get(service, 'name', ''),
    duration: get(service, 'default_duration', ''),
    equipmentType: equipmentType || '',
  };
};

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('field is required'),
  duration: Yup.number().required('field is required'),
  equipmentType: Yup.string(),
});
